import {ChangeEvent} from 'react'
import {
  FormControl,
  IconButton,
  Link,
  Stack,
  Typography,
  TextField,
  CircularProgress
} from '@mui/material'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import {ReactComponent as DeleteIcon} from 'src/images/delete.svg'
import Attachment from 'src/entities/Attachment'
import {grey} from '@mui/material/colors'
import {useFormContext} from 'react-hook-form'

export interface FileProps {
  attachment: Attachment
  onUpload: (id: number, file: File) => void
  onDelete: (id: number) => void
}
const File = (props: FileProps) => {
  const {attachment, onUpload, onDelete} = props
  const {watch} = useFormContext()

  const onUploadFile = (event: ChangeEvent<HTMLInputElement>) => {
    const {files} = event.target
    if (files) {
      onUpload(attachment.Id, files[0])
    }
    event.target.value = ''
  }

  const onDeleteFile = () => {
    onDelete(attachment.Id)
  }

  const hostAssociationConfirmationIsRequired =
    !watch('isAssociationBelongTo') &&
    attachment.CategoryId === 5 &&
    !attachment.File

  return (
    <FormControl sx={{width: '100%'}}>
      <Stack spacing={0.5}>
        <Typography variant="caption" fontSize={13}>
          {attachment.Description}
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          value={
            attachment.IsUploading
              ? 'המסמך עולה'
              : attachment.File
              ? attachment.File.name
              : 'העלאת מסמך'
          }
          InputProps={{
            readOnly: true,
            style: {
              paddingLeft: 8,
              width: '100%',
              fontSize: 12,
              color: grey[600]
            },
            endAdornment: (
              <IconButton
                component={'label'}
                sx={{borderLeft: 1, borderRadius: 0}}
              >
                {attachment.IsUploading ? (
                  <CircularProgress sx={{color: '#0C4968'}} size={24} />
                ) : attachment.File ? (
                  <DeleteIcon
                    width={24}
                    height={24}
                    onClick={e => {
                      e.preventDefault()
                      onDeleteFile()
                    }}
                  />
                ) : (
                  <>
                    <AttachFileIcon />
                    <input
                      style={{display: 'none'}}
                      type="file"
                      hidden
                      accept={attachment.AllowFormat}
                      onChange={onUploadFile}
                      name="[licenseFile]"
                    />
                  </>
                )}
              </IconButton>
            )
          }}
        />
        {attachment.DescriptionAfter && (
          <Typography variant="caption">
            {attachment.DescriptionAfter}
          </Typography>
        )}
        {attachment.UrlDownload && (
          <Link variant="caption" href={attachment.UrlDownload} download>
            יש ללחוץ על מנת להוריד את הטופס למלא ולצרף.
          </Link>
        )}
        {((props.attachment.IsRequierd && !props.attachment.File) ||
          hostAssociationConfirmationIsRequired) && (
          <Typography sx={{color: '#d32f2f', fontSize: '0.75rem'}}>
            חובה להעלות קובץ
          </Typography>
        )}
      </Stack>
    </FormControl>
  )
}

export default File
